import { BuiltinInterface } from '../BuiltinInterface';
class IteratorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Iterator', new IteratorInterface());
};

//# sourceMappingURL=index.js.map
